import styled from 'styled-components';
import { currentContentConfig } from 'utils/handleCurrentContentConfig.js';
import { pageContainerMixin } from 'styles/AppStyles';

export const Container = styled.main`
  ${pageContainerMixin}
  padding-top: 0.5rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  opacity: ${({ $assetsLoaded }) => ($assetsLoaded ? 1 : 0)};
  transition: opacity 0.4s ease-in-out;

  @media (max-width: 670px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

// eslint-disable-next-line
export const Banner = styled.img.attrs(({ $banner }) => ({
  // src: currentContentConfig.defaultBanner,
  src: $banner || currentContentConfig.defaultBanner,
}))`
  border-radius: 2rem;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  @media (max-width: 670px) {
    border-radius: 0;
  }
`;

export const Nothing = styled.h2`
  font-size: 48px;
  text-align: center;
`;
